import React from 'react';
import ReportViewer from "./base/ReportViewer";

const PointsEauAFermer = () => {

    return (
        <div style={{height: "100%"}}>
            <ReportViewer reportName={"PointsEauAFermer"}/>
        </div>
    );
}
export default PointsEauAFermer;